__webpack_require__.p = "/js/blesk-horoskopy/dist/";